
import React, { createContext, useState, useMemo, useContext, useEffect } from "react"

import { fnGetPainel, getPaineis } from "../services/paineis"
import useDataApi from "../hooks/useDataApi.js"
import AuthContext from "./Auth"
import { fnIsResponsible } from "../utils/permissions"
import { fnGetBoards } from "../services/boards"

export const PaineisContext = createContext(null)

export const C_SELECTED_PANELS_STORAGE_KEY = "aSelectedPanels"

export const PaineisContextProvider = ({ children }) => {
  const [paineis, fetchPaineis] = useDataApi(getPaineis)
  const [selectedPaineis, setSetlectedPaineis] = useState([])
  const [fetchedSelectedPaineis, fetchSelectedPaineis] = useDataApi(getPaineis)
  const [oPanelRes, fnGetPanelReq] = useDataApi(fnGetPainel)
  const [oCurrentPanel, fnSetOCurrentPanel] = useState(null)
  const [oBoardsRes, fnGetBoardsReq] = useDataApi(fnGetBoards)

  // modals panel
  const [bIsOpenAddPanel, fnSetBIsOpenAddPanel] = useState(false)
  const [bIsEditPanel, fnSetBIsEditPanel] = useState(false)
  const [bIsOpenDeleteAlertPanel, fnSetBIsOpenDeleteAlertPanel] = useState(false)
  const [bIsOpenDeleteWarningPanel, fnSetBIsOpenDeleteWarningPanel] = useState(false)
  const [bIsOpenDeletePanel, fnSetBIsOpenDeletePanel] = useState(false)
  const [bUpdatePanelsList, fnSetBUpdatePanelsList] = useState(false)

  const { oUser } = useContext(AuthContext)

  const nUserId = oUser?.data?.user_nid

  useEffect(() => {
    if (!oCurrentPanel) return

    const bIsResponsible = fnIsResponsible(nUserId, oCurrentPanel?.responsibles)
    if (oCurrentPanel?.bIsResponsible === bIsResponsible) return
    fnSetOCurrentPanel({ ...oCurrentPanel, bIsResponsible })
  }, [oCurrentPanel])


  const getSelectedPaineisStorage = sessionStorage.getItem(C_SELECTED_PANELS_STORAGE_KEY) ? JSON.parse(sessionStorage.getItem(C_SELECTED_PANELS_STORAGE_KEY)) : []
  const setSelectedPaineisStorage = (paineis) => {
    sessionStorage.setItem(C_SELECTED_PANELS_STORAGE_KEY, JSON.stringify(paineis || []))
  }

  const removeSelectedPainelFromStorage = (painel) => {
    if (!painel) return

    const index = getSelectedPaineisStorage.indexOf(painel)
    getSelectedPaineisStorage.splice(index, 1)

    setSelectedPaineisStorage(getSelectedPaineisStorage)
  }

  const getSelectedPaineis = async (bReload = false) => {
    if (!getSelectedPaineisStorage?.length) return

    const noDataPaineis = []
    let currentPaineis = paineis?.data?.data?.data || []
    getSelectedPaineisStorage.map(s => {
      const painel = currentPaineis?.find(p => p?.id === s)
      if (!painel) noDataPaineis.push(s)
    })

    if (noDataPaineis?.length > 0 || bReload) {
      const aSelectedPanelsIds = bReload ? getSelectedPaineisStorage : noDataPaineis?.map(s => s)
      const response = await fetchSelectedPaineis(`ids=${aSelectedPanelsIds}`)
      currentPaineis = bReload ? response?.data?.data : [...currentPaineis, ...(response?.data?.data || [])]
    }

    const selectedPaineisData = getSelectedPaineisStorage.map(s => {
      const painel = currentPaineis.find(p => p?.id === s)
      if (painel) return painel
      if (!painel) removeSelectedPainelFromStorage(s)
    })

    setSetlectedPaineis(selectedPaineisData?.filter(s => s))
  }

  const handleSetSelectedPainel = (painel) => {
    if (!painel) return

    fnSetOCurrentPanel(painel)
    if (!getSelectedPaineisStorage.includes(painel.id)) {
      const setPanels = getSelectedPaineisStorage?.length ? [painel?.id, ...getSelectedPaineisStorage] : [painel?.id]
      setSetlectedPaineis([painel, ...selectedPaineis])
      setSelectedPaineisStorage(setPanels)
      return
    }

    const setPanels = [painel?.id, ...getSelectedPaineisStorage.filter(p => p !== painel?.id)]
    setSetlectedPaineis([painel, ...selectedPaineis.filter(p => p?.id !== painel?.id)])
    setSelectedPaineisStorage(setPanels)
  }

  const handleOnClosePainel = (painel) => {
    if (!painel) return

    const setPanels = getSelectedPaineisStorage.filter(p => p !== painel?.id)
    setSetlectedPaineis(selectedPaineis.filter(p => p?.id !== painel?.id))
    setSelectedPaineisStorage(setPanels)
  }

  async function fnGetCurrentPanel(nPanelId) {
    if (!nPanelId) return

    if (oCurrentPanel?.id === nPanelId || oPanelRes.loading) return

    const response = await fnGetPanelReq(nPanelId)
    const oPanel = response?.data?.data?.length > 0 ? response?.data?.data[0] : null
    fnSetOCurrentPanel(oPanel)
  }

  const value = useMemo(() => {
    return {
      paineis,
      fetchPaineis,
      selectedPaineis,
      getSelectedPaineis,
      handleSetSelectedPainel,
      handleOnClosePainel,
      fetchedSelectedPaineis,
      oCurrentPanel,
      fnSetOCurrentPanel,
      bIsOpenAddPanel,
      fnSetBIsOpenAddPanel,
      bIsEditPanel,
      fnSetBIsEditPanel,
      bIsOpenDeleteAlertPanel,
      fnSetBIsOpenDeleteAlertPanel,
      bIsOpenDeleteWarningPanel,
      fnSetBIsOpenDeleteWarningPanel,
      bIsOpenDeletePanel,
      fnSetBIsOpenDeletePanel,
      bUpdatePanelsList,
      fnSetBUpdatePanelsList,
      fnGetCurrentPanel,
      oBoardsRes,
      fnGetBoardsReq
    }
  }, [
    paineis,
    selectedPaineis,
    oCurrentPanel,
    bIsOpenAddPanel,
    bIsEditPanel,
    bIsOpenDeletePanel,
    bIsOpenDeleteWarningPanel,
    bIsOpenDeleteAlertPanel,
    bUpdatePanelsList,
    oBoardsRes
  ])

  return (
    <PaineisContext.Provider value={value}>
      {children}
    </PaineisContext.Provider>
  )
}

export default PaineisContext
